import createRowExpander from '../row-expander-base.js';
import { bindCopyTextButtons } from '../../shared/copy-text-button.js';
import config from './config.js';
import rowKey from './row-key.js';
import ids from './ids.js';
import loader from './loader.js';
import actionButtons from './action-buttons.js';
import rowExpanderContent from './row-expander-content.js';
import dom from './dom.js';
import api from './api.js';
import memberExpandPanels from '../pledges/member-expand-panels.js';
import paymentDetails from '../payments/payment-details.js';
import memberDetails from '../members/member-details.js';
import toggle from './toggle.js';

bindCopyTextButtons();

const rowExpanderStrategy = {
    getRowKey: ($row) => rowKey.getRowKey($row),
    getDetailRowId: (key) => ids.getDetailRowId(key),
    gridSelector: 'body',
    rowSelector: '.clickable-row',
    expandedContainerSelector: '.clickable-row'
};

const baseRowExpander = createRowExpander(rowExpanderStrategy);

const RowExpander = Object.assign(
    {},
    config,
    rowKey,
    ids,
    loader,
    actionButtons,
    rowExpanderContent,
    dom,
    api,
    memberExpandPanels,
    paymentDetails,
    memberDetails,
    baseRowExpander,
    toggle
);

const boundRowExpanderGrids = new WeakSet();

function resolveRowExpanderGrid(options) {
    if (options.gridElement instanceof HTMLElement) {
        return options.gridElement;
    }
    const gridId = String(options.gridId || '').trim();
    if (!gridId) {
        throw new Error('initializeRowExpander: gridId is required');
    }
    const grid = document.getElementById(gridId);
    if (!grid) {
        throw new Error('initializeRowExpander: #' + gridId + ' is required');
    }
    return grid;
}

function bindRowExpanderGridRenderHandler(grid) {
    if (boundRowExpanderGrids.has(grid)) {
        return;
    }
    boundRowExpanderGrids.add(grid);
    grid.addEventListener('data-grid-rendered', () => {
        RowExpander.attachClickHandler();
        if (RowExpander.rowActionHandlers) {
            RowExpander.attachRowActionClickHandler();
        }
        RowExpander.attachExpandContentDelegation();
        RowExpander.hydrateMobileRowActions();
    });
}

export function initializeRowExpander(options) {
    if (!options || typeof options !== 'object') {
        throw new Error('initializeRowExpander: options is required');
    }
    if (typeof RowExpander.init !== 'function') {
        throw new Error('initializeRowExpander: init is required');
    }

    RowExpander.init(options);

    const grid = resolveRowExpanderGrid(options);

    bindRowExpanderGridRenderHandler(grid);

    const initGuardAttr = grid.id === 'members-grid' ? 'data-members-grid-init' : 'data-pledges-grid-init';
    if (grid.getAttribute(initGuardAttr) === '1') {
        requestAnimationFrame(() => RowExpander.hydrateMobileRowActions());
    }

    return RowExpander;
}

export default RowExpander;
